import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Объединяет условные классы и разрешает конфликты Tailwind-утилит.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Помечает статичную строку Tailwind-классов для автодополнения в IDE.
 * В рантайме возвращает строку без изменений.
 */
export function tw<T extends string>(classes: T) {
  return classes
}
